
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import { _ as _objectSpread } from './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import PendoIcon from './pendo-icon.js';
import 'v-tooltip';
import './tooltip-mixin.js';
import PendoTooltip from './pendo-tooltip.js';
import 'lodash/isNumber';
import './table-auto-height-mixin.js';
import 'lodash/isFunction';
import { h as shouldAttachOverflowTooltip } from './multiselect-helper-mixin.js';

var script = {
  name: 'PendoGroupOption',
  components: {
    PendoIcon
  },
  directives: {
    PendoTooltip
  },
  props: {
    option: {
      type: [Object, String],
      required: true
    }
  },
  inject: ['multiselect'],

  data() {
    return {
      showOverflowTooltip: false,
      tooltipTimeout: null
    };
  },

  computed: {
    label() {
      return this.multiselect.getOptionLabel(this.option);
    },

    group() {
      let content = 'No Product Area';

      if (this.option.group && this.option.group.name) {
        content = this.option.group.name;
      }

      return content;
    },

    color() {
      if (this.option.group && this.option.group.color) {
        let color = this.option.group.color;

        if (color.includes('.')) {
          color = color.substr(1);
        }

        return {
          groupColor01: '#ec2059',
          groupColor02: '#ff7e8e',
          groupColor03: '#ff7107',
          groupColor04: '#ffb053',
          groupColor05: '#00c583',
          groupColor06: '#03ed9f',
          groupColor07: '#009bd5',
          groupColor08: '#34c8ff',
          groupColor09: '#8369c1',
          groupColor10: '#af90f8',
          groupColorUngrouped: '#dadce5'
        }[color];
      }

      return '#dadce5';
    },

    icon() {
      return _objectSpread({
        size: 14
      }, this.option.icon);
    }

  },
  methods: {
    onOptionMouseenter() {
      const showOverflowTooltip = shouldAttachOverflowTooltip(this.label, this.$refs.label);

      if (showOverflowTooltip) {
        clearTimeout(this.tooltipTimeout);
        this.tooltipTimeout = setTimeout(() => {
          this.showOverflowTooltip = true;
        }, 300);
      }
    },

    onOptionMouseleave() {
      clearTimeout(this.tooltipTimeout);
      this.showOverflowTooltip = false;
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', _vm._g(_vm._b({
    staticClass: "pendo-multiselect-option--group",
    class: {
      'pendo-multiselect-option--group-icon': !!_vm.option.icon
    }
  }, 'div', _vm.$attrs, false), _vm.$listeners), [_c('svg', {
    directives: [{
      name: "pendo-tooltip",
      rawName: "v-pendo-tooltip",
      value: {
        content: _vm.group,
        delay: {
          show: 300,
          hide: 0
        },
        multiline: true
      },
      expression: "{\n            content: group,\n            delay: { show: 300, hide: 0 },\n            multiline: true,\n        }"
    }],
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "width": "12",
      "height": "12"
    }
  }, [_c('rect', {
    attrs: {
      "width": "12",
      "height": "12",
      "x": "0",
      "y": "0",
      "fill": _vm.color,
      "rx": "2"
    }
  })]), _vm._v(" "), _vm.option.icon ? _c('pendo-icon', _vm._b({}, 'pendo-icon', _vm.icon, false)) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "pendo-tooltip",
      rawName: "v-pendo-tooltip",
      value: {
        content: _vm.label,
        multiline: true,
        html: false,
        trigger: 'manual',
        offset: 0,
        show: _vm.showOverflowTooltip
      },
      expression: "{\n            content: label,\n            multiline: true,\n            html: false,\n            trigger: 'manual',\n            offset: 0,\n            show: showOverflowTooltip\n        }"
    }],
    ref: "label",
    staticClass: "pendo-multiselect-option__label",
    on: {
      "mouseenter": _vm.onOptionMouseenter,
      "mouseleave": _vm.onOptionMouseleave
    }
  }, [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")])], 1);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-group-option.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoGroupOption = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default PendoGroupOption;
